"use client";

import urls from '@/utils/urls/urls';
import axios from 'axios';
import React, { useState } from 'react';
import toast from 'react-hot-toast';

const SubcribeForm = () => {
    const [formData, setFormData] = useState({
        email: '',
    });

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        try {

            // console.log("formData >", formData)
            const response = await axios.post(urls?.subscribe, formData);

            // console.log("response >", response)

            if (response?.data?.data) {
                toast.success('Subcribed Successfully!');
                setFormData({
                    email: '',
                });
            } else {
                alert('Error sending message.');
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error sending message.');
        }
    };

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <div className="form-icon">
                        <i className="far fa-envelopes" />
                        <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Your Email"
                            onChange={handleChange}
                            value={formData.email}
                            required
                        />
                        <button className="theme-btn" type="submit">
                            Subscribe <span className="far fa-paper-plane" />
                        </button>
                    </div>
                </div>
            </form>

            {/* <form onSubmit={handleSubmit} id="contact-form">
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <div className="form-icon">
                                <i className="far fa-envelope" />
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    placeholder="Your Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <button type="submit" className="theme-btn">
                    Subscribe <i className="far fa-paper-plane" />
                </button>
            </form> */}
        </>
    );
};

export default SubcribeForm;
